import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateApproveEmployer = {
  approveEmployer: { data: null, loading: false, error: null },
};

export const approveEmployer = createAsyncThunk('user/approveEmployer', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .put(
      `${process.env.REACT_APP_SERVER_API}/employers/${data.id}/verification/result`,
      {
        status: 'approved',
        comment: null,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
      },
    )
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerApproveEmployer = {
  [approveEmployer.pending]: (state) => {
    state.approveEmployer.loading = true;
    state.approveEmployer.error = null;
  },
  [approveEmployer.fulfilled]: (state, action) => {
    state.approveEmployer.loading = false;
    state.approveEmployer.data = true;
    state.approveEmployer.error = null;
  },
  [approveEmployer.rejected]: (state, action) => {
    state.approveEmployer.loading = false;
    state.approveEmployer.error = action.payload;
  },
};
